import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { LogoutScreen } from '../components/Authentication/Login';
import { LoadingPage } from '../components/Shared';
import { AuthService, LaunchDarkly } from '../services';

enum SessionStatus {
  SigningIn,
  SignedIn,
  SigningOut,
  SignedOut,
}

export const withAuthentication = (Component: React.FC<any>) => {
  const ComponentWithAuthentication = (): JSX.Element => {
    const [sessionStatus, setSessionStatus] = useState<SessionStatus>(
      SessionStatus.SigningIn
    );
    const [logoutMessage, setLogoutMessage] = useState<string>();

    useEffect(() => {
      AuthService.onSigningOut = (message: string) => {
        setLogoutMessage(message);
        setSessionStatus(SessionStatus.SigningOut);
      };
      AuthService.onSignedOut = () => setSessionStatus(SessionStatus.SignedOut);

      (async () => {
        if (await AuthService.signinSilent()) {
          await LaunchDarkly.initializeClient(await AuthService.getUser());
          setSessionStatus(SessionStatus.SignedIn);
        } else {
          setSessionStatus(SessionStatus.SignedOut);
        }
      })().catch(error => console.error(error));

      return () => {
        AuthService.onSigningOut = () => {};
        AuthService.onSignedOut = () => {};
      };
    }, []);

    switch (sessionStatus) {
      case SessionStatus.SigningOut:
        return <LogoutScreen subtext={logoutMessage} />;
      case SessionStatus.SignedOut:
        return <Redirect to={`/login?referrer=${location.pathname}`} />;
      case SessionStatus.SignedIn:
        const MemoizedComponent = React.memo(Component);
        return <MemoizedComponent />;
      default:
        return <LoadingPage subtext='Getting things ready...' fullscreen />;
    }
  };

  return ComponentWithAuthentication;
};
